






































































































import { defineComponent, PropType } from 'vue';
import { iconClassEnum } from '../../../../shared/enums/iconClassEnum';
import Mention from '../../../../shared/components/Mention.vue';
import EventDetail from './EventDetail.vue';
import Avatar from '../../../../shared/components/Avatar.vue';
import { EventData } from '../../../business/calendar/eventData';

export default defineComponent({
  components: { Avatar, EventDetail, Mention },
  props: {
    eventData: { type: Object as PropType<EventData>, required: true },
  },
  computed: {
    iconClassEnum() {
      return iconClassEnum;
    },
  },
});
